import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight * 0.8;
      setIsVisible(window.scrollY > heroHeight);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-50" role="complementary" aria-label="Comprar ahora" data-id="element-2">
          <div className="backdrop-blur-md border-t px-4 py-3 sm:py-4" style={{
        backgroundColor: 'rgba(11, 26, 46, 0.92)',
        borderColor: 'rgba(212, 160, 23, 0.25)'
      }} data-id="element-3">
            <div className="max-w-2xl mx-auto flex items-center justify-between gap-4" data-id="element-4">
              <div className="hidden sm:block" data-id="element-5">
                <p className="font-serif-display font-bold text-lg" style={{
              color: '#FAF3E8'
            }} data-id="element-6">
                  El Método Express
                </p>
                <p className="text-sm" style={{
              color: 'rgba(250, 243, 232, 0.6)'
            }} data-id="element-7">
                  7 Arreglos que Pagan la Renta
                </p>
              </div>
              <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-8">
                <div className="flex items-center gap-2" data-id="element-9">
                  <span className="font-body text-base line-through" style={{
                color: 'rgba(250, 243, 232, 0.4)'
              }} data-id="element-10">
                    $27
                  </span>
                  <span className="font-serif-display font-bold text-2xl sm:text-3xl" style={{
                color: '#D4A017'
              }} data-id="element-11">
                    $6.39
                  </span>
                  <span className="hidden sm:inline-block px-1.5 py-0.5 rounded text-xs font-bold" style={{
                backgroundColor: '#C0392B',
                color: '#fff'
              }} data-id="element-12">
                    -76%
                  </span>
                </div>
                <a href="https://manosquegeneran.com/cart/48283475017955:1" target="_blank" rel="noopener noreferrer" className="cta-glow flex-1 sm:flex-none inline-flex items-center justify-center px-6 py-3 rounded-lg font-bold text-base transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95" style={{
              backgroundColor: '#D4A017',
              color: '#1A1A1A'
            }} aria-label="Descarga el Método Express por $6.39" data-id="element-13">
                  Descargar Ahora
                </a>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}